import React from 'react'
import ReactDOM from 'react-dom'
import ExtensionService from 'live/services/extension'
import Router from 'live/services/router'
import Admin from './components/admin'
import Popup from './components/popup'
import i18n from 'live/services/i18n'
import ptBr from './services/i18n/pt_br'
import enUs from './services/i18n/en_us'

const currentUser = (window as any)?.Live?.currentUser || (typeof Live !== 'undefined' ? Live?.currentUser : null)
const isLoggedIn = currentUser && Object.keys(currentUser).length !== 0

if (isLoggedIn) {

    const Live = window.Live
    const locale = Live && Live.settings && Live.settings.locale ? Live.settings.locale : 'en_us'
    const localeFiles = {
        pt_br: ptBr,
        en_us: enUs
    }
    i18n.add(localeFiles[locale])

    const adminConfig = {
        name: i18n('NPS Survey'),
        url: '#nps-survey',
        alias: 'nps-survey',
        ico: 'fas fa-star-half-alt',
        position: 'first-block',
        addRoute: false,
        routeUrl: null,
        component: null
    }

    Router.route('nps-survey', Admin, 'nps-survey')
    ExtensionService.addAdminMenu(adminConfig)

    const popupRootId = 'plugin-nps-popup-root'
    const existingRoot = document.getElementById(popupRootId)
    const popupRoot = existingRoot || document.createElement('div')

    if (!existingRoot) {
        popupRoot.id = popupRootId
        document.body.appendChild(popupRoot)
    }

    ReactDOM.render(<Popup userId={Number(currentUser.id)} />, popupRoot)
}
